import React, { useContext } from 'react';
import { validations, checkValidation } from '../../../utils/FormValidators';
import './../../../styles/irctcCreateAccountForms.css';
import InputField from '../../components/InputField';
import SelectItem from '../../components/SelectItem';
import { CREATE_ACCOUNT_FORM_ELEMENT_ID, SERVER_URL } from '../../../utils/RailsSEOConstants';
import axios from 'axios';
import * as irctcCreateAccountActions from './../../../actions/irctcCreateAccountActions';
import { IrctcCreateAccountContext } from '../IrctcCreateAccountPage';
import { isMobile } from '../../../utils/commonUtils';

const AccountSetupForm = () => {
  const isMobileDevice = isMobile();
  const context = useContext(IrctcCreateAccountContext);
  const {
    createAccountState: {
      userName,
      userEmail,
      mobileNumber,
      showErrorCreateAccount,
      userNameErrorMessage,
      userEmailErrorMessage,
      mobileNumberErrorMessage,
      password,
      selectedSecurityQuestion,
      securityQuestionList,
      securityAnswer
    },
    createAccountDispatch
  } = context;

  const updateUserNameErrorMessage = (latestUserNameErrorMessage) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_USERNAME_ERROR_MSG_CREATE_ACCOUNT,
      data: latestUserNameErrorMessage
    });
  };
  const updateUserEmailErrorMessage = (latestUserEmailErrorMessage) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_USER_EMAIL_ERROR_MSG_CREATE_ACCOUNT,
      data: latestUserEmailErrorMessage
    });
  };
  const updateMobileNumberErrorMessage = (latestMobileNumberErrorMessage) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_MOBILE_NUMBER_ERROR_MSG_CREATE_ACCOUNT,
      data: latestMobileNumberErrorMessage
    });
  };
  const checkUserNameAvailable = async (latestUserName) => {
    try {
      let userNameError = '';
      if (checkValidation(latestUserName, validations.userName)) {
        const body = { userid: latestUserName };
        const res = await axios.post(`${SERVER_URL}/userAvailability`, body);
        if (res.data.useridAvailable === 'FALSE') {
          userNameError = 'User name is already registered';
        } else if (res.data.useridAvailable === 'TRUE') {
          userNameError = '';
        } else if (res.data.errorMessage) {
          userNameError = res.data.errorMessage;
        }
      }
      updateUserNameErrorMessage(userNameError);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
  const checkUserEmailAvailable = async (latestUserEmail) => {
    try {
      let userEmailError = '';
      if (checkValidation(latestUserEmail, validations.email)) {
        const body = { email: latestUserEmail };
        const res = await axios.post(`${SERVER_URL}/userAvailability`, body);
        if (res.data.emailAvailable === 'FALSE') {
          userEmailError = 'Email is already registered';
        } else if (res.data.emailAvailable === 'TRUE') {
          userEmailError = '';
        } else if (res.data.errorMessage) {
          userEmailError = res.data.errorMessage;
        }
      }
      updateUserEmailErrorMessage(userEmailError);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
  const checkMobileNumberAvailable = async (latestMobileNumber) => {
    try {
      let mobileError = '';
      if (checkValidation(latestMobileNumber, validations.mobileNumber)) {
        const body = { mobile: latestMobileNumber };
        const res = await axios.post(`${SERVER_URL}/userAvailability`, body);
        if (res.data.mobileAvailable === 'FALSE') {
          mobileError = 'Mobile number is already registered';
        } else if (res.data.mobileAvailable === 'TRUE') {
          mobileError = '';
        } else if (res.data.errorMessage) {
          mobileError = res.data.errorMessage;
        }
      }
      updateMobileNumberErrorMessage(mobileError);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  const updateUserName = (latestUserName) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_USERNAME_CREATE_ACCOUNT,
      data: latestUserName
    });
  };
  const updateUserEmail = (latestUserEmail) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_USERMAIL_CREATE_ACCOUNT,
      data: latestUserEmail
    });
  };
  const updateMobileNumber = (latestMobileNumber) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_MOBILE_NUMBER_CREATE_ACCOUNT,
      data: latestMobileNumber
    });
  };
  const updatePassword = (latestPassword) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_PASSWORD_CREATE_ACCOUNT,
      data: latestPassword
    });
  };
  const updateSelectedSecurityQuestion = (latestSelectedSecurityQuestion) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_SELECTED_QUESTION_CREATE_ACCOUNT,
      data: latestSelectedSecurityQuestion
    });
  };
  const updateSecurityAnswer = (latestSecurityAnswer) => {
    createAccountDispatch({
      type: irctcCreateAccountActions.ACTION_SET_SECURITY_ANSWER_CREATE_ACCOUNT,
      data: latestSecurityAnswer
    });
  };

  return (
    <div className={`irctcDetailsComp__acc`}>
      <div className={`makeFlex ${isMobileDevice ? 'column' : ''} appendBottom40`}>
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.userName} />
        {!isMobileDevice && (
          <InputField
            value={userName}
            updateParentValue={updateUserName}
            label="Create Username"
            placeholder="Type a username"
            customClass="appendRight30"
            validations={validations.userName}
            error={
              !!userNameErrorMessage || (showErrorCreateAccount && !checkValidation(userName, validations.userName))
            }
            errorMsg={userNameErrorMessage || 'Enter a valid username'}
            onFocusOutProps={checkUserNameAvailable}
          />
        )}
        {isMobileDevice && (
          <InputField
            value={userName}
            updateParentValue={updateUserName}
            label="Create UserName"
            placeholder="Type a username"
            customClass="appendBottom30"
            validations={validations.userName}
            error={
              !!userNameErrorMessage || (showErrorCreateAccount && !checkValidation(userName, validations.userName))
            }
            errorMsg={userNameErrorMessage || 'Enter a valid username'}
            onFocusOutProps={checkUserNameAvailable}
          />
        )}
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.userEmail} />
        <InputField
          value={userEmail}
          updateParentValue={updateUserEmail}
          label="Enter your Email Address"
          placeholder="OTP will be sent to this email"
          error={!!userEmailErrorMessage || (showErrorCreateAccount && !checkValidation(userEmail, validations.email))}
          errorMsg={userEmailErrorMessage || 'Enter a valid email address'}
          onFocusOutProps={checkUserEmailAvailable}
        />
      </div>
      <div className={`makeFlex ${isMobileDevice ? 'column' : ''} appendBottom40`}>
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.mobileNumber} />
        {!isMobileDevice && (
          <InputField
            value={mobileNumber}
            label="Enter your Mobile Number"
            updateParentValue={updateMobileNumber}
            mobNum="true"
            customClass="appendRight30"
            placeholder="OTP will be sent to this mobile number"
            maxLength={10}
            error={
              !!mobileNumberErrorMessage ||
              (showErrorCreateAccount && !checkValidation(mobileNumber, validations.mobileNumber))
            }
            errorMsg={mobileNumberErrorMessage || 'Enter a valid mobile number'}
            onFocusOutProps={checkMobileNumberAvailable}
          />
        )}
        {isMobileDevice && (
          <InputField
            value={mobileNumber}
            label="Enter your Mobile Number"
            updateParentValue={updateMobileNumber}
            mobNum="true"
            customClass="appendBottom30"
            placeholder="OTP will be sent to this mobile number"
            maxLength={10}
            error={
              !!mobileNumberErrorMessage ||
              (showErrorCreateAccount && !checkValidation(mobileNumber, validations.mobileNumber))
            }
            errorMsg={mobileNumberErrorMessage || 'Enter a valid mobile number'}
            onFocusOutProps={checkMobileNumberAvailable}
          />
        )}
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.password} />
        <InputField
          value={password}
          updateParentValue={updatePassword}
          eyeIcon={true}
          label="Enter your Password"
          placeholder="Type a password for your IRCTC account"
          validations={validations.password}
          error={showErrorCreateAccount && !checkValidation(password, validations.password)}
          errorMsg="Enter a valid password"
        />
      </div>
      <div className={`makeFlex ${isMobileDevice ? 'column' : ''}`}>
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.securityQuestion} />
        {!isMobileDevice && (
          <SelectItem
            selectOption={securityQuestionList}
            labelText="Select your security question"
            customClass="appendRight30"
            selectedIndex={selectedSecurityQuestion}
            updateParentIndex={updateSelectedSecurityQuestion}
          />
        )}
        {isMobileDevice && (
          <SelectItem
            selectOption={securityQuestionList}
            labelText="Select your security question"
            customClass="appendBottom30"
            selectedIndex={selectedSecurityQuestion}
            updateParentIndex={updateSelectedSecurityQuestion}
          />
        )}
        <div id={CREATE_ACCOUNT_FORM_ELEMENT_ID.securityAnswer} />
        <InputField
          value={securityAnswer}
          updateParentValue={updateSecurityAnswer}
          label="Enter a Security answer"
          placeholder="Type an answer for your security question"
          validations={validations.securityAnswer}
          error={showErrorCreateAccount && !checkValidation(securityAnswer, validations.securityAnswer)}
          errorMsg={'Enter a valid security answer'}
        />
      </div>
    </div>
  );
};

export default AccountSetupForm;
